import { Flex, Typography } from '@banhala/ui-kit';
import { isNotNil } from 'shared/src/utils';
import { IconBrandIconToday } from '../../../IconBrandIconToday';

export const PricingTodayDeliveryBadge = ({
  orderDeadline,
}: {
  orderDeadline: string | null;
}) => (
  <Flex.Row gap={4} alignItems={'center'}>
    <Flex
      padding={{ horizontal: 6, vertical: 3 }}
      backgroundColor={'blue5'}
      borderRadius={10}
    >
      <IconBrandIconToday width={41} height={11} />
    </Flex>
    {isNotNil(orderDeadline) && (
      <Typography type={'body4'} color={'content_slate_primary'}>
        {orderDeadline}
      </Typography>
    )}
  </Flex.Row>
);
